import { Controller } from "@hotwired/stimulus";

// Dispatches drawer:open so a drawer elsewhere on the page can open (e.g. when link is inside overflow-clip and drawer is at body level).
// Passes the target frame id so only the matching drawer opens when multiple drawers exist.
export default class extends Controller {
  open() {
    // Read from the element that has the controller (the link); getAttribute is more reliable than dataset
    const frameId = this.element.getAttribute("data-turbo-frame") || this.element.dataset?.turboFrame || null;
    document.dispatchEvent(new CustomEvent("drawer:open", { detail: { frameId } }));
  }
}
